import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';

import { MultiViewComponentType } from './enums/multi-view-component-type.enum';

@Directive({
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: '[multiViewComponent]'
})
export class MultiViewComponentDirective implements OnInit {
	@Input('multiViewComponent') public viewType: MultiViewComponentType;
	@Input() public portfolioCount?: number;
	@Input() public breakpoint?: number;

	constructor(
		private templateRef: TemplateRef<any>,
		private viewContainer: ViewContainerRef
	) { }

	public ngOnInit(): void {
		this.setDisplay();
	}

	private setDisplay(): void {
		if (
			this.portfolioCount <= this.breakpoint && this.viewType === MultiViewComponentType.Split ||
			this.portfolioCount > this.breakpoint && this.viewType === MultiViewComponentType.Toggled ||
			!this.portfolioCount && !this.breakpoint && this.viewType === MultiViewComponentType.Radio
		) {
			this.viewContainer.createEmbeddedView(this.templateRef);
		} else {
			this.viewContainer.clear();
		}
	}
}
